<template>
    <div>
        <q-score-card key="QScoreCardClosed" title="Closed" api-endpoint="closed" drill-down-label="Policy Breakdown" :drill-down-route="drillDownRoute ? drillDownRoute : 'Closed Policies'" card-style="production" :agent-code="agentCode" :filters="filters" :default-goal="defaultGoal" format="Currency" :show-drill-down-on-personal="true">
            Note: Policies that were submitted, but did not turn into a placed policy - updated weekly on Wednesday.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardClosed",
    props: ["agentCode", "filters", "defaultGoal", "drillDownRoute"],
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {},
    computed: {

    },
    methods: {

    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
